/**
 * New Orbit Status that matches the OrbitCommands intent.
 */
export var OrbitStatus;
(function (OrbitStatus) {
    OrbitStatus["pause"] = "pause";
    OrbitStatus["playing"] = "playing";
    OrbitStatus["stopped"] = "stopped";
})(OrbitStatus || (OrbitStatus = {}));
//# sourceMappingURL=orbit-status.js.map